import React, { useMemo, useReducer } from "react";
import InlineDialog from "../../../components/InlineDialog";
import { useTranslate } from "../../../contexts/languageContext";

const initialState = { show: false, data: null };

export function useEchartsModal() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const events = useMemo(
    () => ({
      click: (params, _chartInstance) => {
        !params.data.tipData.noModal &&
          dispatch({ type: "show", data: params.data.tipData });
      },
    }),
    []
  );
  return { state, dispatch, events };
}

function reducer(state, event) {
  switch (event.type) {
    case "show":
      return { data: event.data, show: true };
    case "hide":
      return { data: state.data, show: false };
    default:
      throw new Error();
  }
}

export function EchartsModal({ className, children, dispatch }) {
  return (
    <div
      css={`
        width: 100%;
        height: 100%;
        z-index: 10000000; // z-index del tooltip de Echarts: 9999999
      `}
      className={className}
    >
      <div
        css={`
          position: relative;
          width: 100%;
          height: 100%;
        `}
      >
        <InlineDialog
          css={`
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: 12px;
            width: 240px;
            box-sizing: border-box;
            border: 1px solid #cccccc;
            border-radius: 5px;
            box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.25);
            white-space: normal;
            font-size: 14px;
            font-weight: 400;
          `}
          onClose={() => {
            dispatch({ type: "hide" });
          }}
        >
          {children}
        </InlineDialog>
      </div>
    </div>
  );
}

export function Button({ onClick, children }) {
  return (
    <button
      onClick={onClick}
      css={`
        color: white;
        background: ${({ theme }) => theme.colors.primary};
        text-align: center;
        padding: 4px;
        border-radius: 5px;
        font-weight: bold;
        font-size: 12px;
        line-height: 1.4;
      `}
    >
      {children}
    </button>
  );
}

export function Close({ dispatch }) {
  const t = useTranslate();
  return (
    <button
      onClick={() => {
        dispatch({ type: "hide" });
      }}
      css={`
        background: transparent;
        border: none;
        width: 44px;
        height: 44px;
        margin: -12px;
      `}
      aria-label={t("cerrar")}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
          fill="black"
          fillOpacity="0.54"
        />
      </svg>
    </button>
  );
}
